import { render, staticRenderFns } from "./AgreementsCallouts.vue?vue&type=template&id=3f8ce3f4&"
import script from "./AgreementsCallouts.vue?vue&type=script&lang=js&"
export * from "./AgreementsCallouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports